import {
  Box, Button, CardActions, Grid, Stack,
  Tooltip,
  Typography
} from '@mui/material';
import { MicrosoftExcel, Printer } from 'mdi-material-ui';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Page from 'src/components/Page';
import PageHeader from 'src/components/page-header';
import { getOrderNumbers } from 'src/utils/shop';
import MenuAccount from 'src/views/menu/MenuAccount';
import TableAccount from 'src/views/order/TableAccount';
import { apiService } from '../../../api/axiosClient';
import BoxWrapper from '../../../styles/BoxWrapper';

const AccountList = () => {
  const [reload, setReload] = useState(0);
  const [filters, setFilters] = useState({});
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  
  const sheetDownload = async () => {
      await apiService.get('/proc/account/excel', {
          params: {
              ...filters
          },
          responseType: 'blob'
      }).then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "회계리스트.xlsx";
          document.body.appendChild(a);
          a.click();
      }).catch(error => {
          console.error(error)
      });
  }

  const onRequestNotify = async (data) => {
    const params = {
      "userName": data.orderer,
      "orderNo": data.orderid,
      "orderDate": data.order_time,
      "orderPrice": data.order_amount,
      "orderContact": data.orderer_contact,
      "com_id": data.com_id
    };

    await apiService.post('/biztalk/cash', params)
    .then(response => {
      toast.success('주문자에게 Biztalk으로 알림이 발송되었습니다.');
    }).catch(error => {
      console.error("Error sending payment request:", error);
    });
  }

  const requestPayment = async () => {
    selected.map((data) => {
      onRequestNotify(data);
    });
  }

  return (
    <Page title="통합회계관리">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                통합회계관리
                </Typography>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              통합회계관리 리스트를 보여줍니다.
            </Typography>
          }
        />
        <BoxWrapper>
            <Box sx={{ width: '100%', typography: 'body1' }}>            
              <MenuAccount setFilters={setFilters} setReload={setReload} />
            </Box>
            
            <TableAccount filters={filters} submit={reload} selected={selected} setSelected={setSelected} 
              page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />

            <CardActions className='card-action-dense'>
                <Stack direction="row" spacing={2}>
                    <Button variant='contained' startIcon={<MicrosoftExcel />} onClick={sheetDownload}>엑셀출력</Button>
                </Stack>
                <Stack direction="row" spacing={2} sx={{pl: 4}}>          
                  <Button component={Link} 
                    to={`/form/order?orderids=${getOrderNumbers(selected)}`} 
                    target="_blank" 
                    variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>거래명세</Button>
                  <Button component={Link} 
                    to={`/form/delivery?orderids=${getOrderNumbers(selected)}`}  
                    target="_blank" 
                    variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>납품명세</Button>
                  <Button component={Link} 
                    to={`/form/spec?orderids=${getOrderNumbers(selected)}`} 
                    target="_blank" 
                    variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>견적서</Button>
                </Stack>
                <Stack direction="row" spacing={2}>
                  <Tooltip title="주문자에게 Biztalk으로 알림이 발송됩니다.">
                    <Button variant='contained' color="warning" onClick={requestPayment}>입금요청</Button>
                  </Tooltip>                    
                </Stack>
            </CardActions>
        </BoxWrapper>
      </Grid>
    </Page>
  )
}

export default AccountList